import React, { useEffect, useState } from "react";

// components
import { Button, Card, CardBody, CardHeader, Form, Row, Col, Spinner } from "reactstrap";
import MaterialTable from 'material-table';

// style
import { table_translate, table_style } from "../../../constants/MaterialTable.js";

// views
import CategoriaFiscalizacaoFicha from "./CategoriaFiscalizacaoFicha.jsx";

// helpers
import { showMessage } from "../../../helpers/message.js";

// api
import categoriafiscalizacao_api from "../../../api/categoriafiscalizacao_api.js";

export default function CategoriaFiscalizacaoLista() {

  const [showLoading, setshowLoading] = useState(false);

  const [list_table, set_list_table] = useState([]);
  const [rowEdit, set_rowEdit] = useState(null);
  const [showDetail, set_showDetail] = useState(false);
  const [isDisable, set_isDisable] = useState(false); // Can be tied to permissions if needed

  const handleAdd = () => {
    set_rowEdit(null);
    set_showDetail(true);
  }

  const handleEdit = (rowData) => {
    setshowLoading(true);
    categoriafiscalizacao_api.getItem(rowData.categoriaFiscalizacao_Id).then(result => {
      setshowLoading(false);
      if (result.status !== 200) {
        showMessage("Aviso", result.message, 'error', null);
      }
      else {
        set_rowEdit(result.data);
        set_showDetail(true);
      }
    });
  }

  const handleReturn = () => {
    set_rowEdit(null);
    set_showDetail(false);
    loadList();
  }

  const loadList = () => {
    setshowLoading(true);
    categoriafiscalizacao_api.getAll().then(result => {
      setshowLoading(false);
      if (result.status !== 200) {
        showMessage("Aviso", result.message, 'error', null);
      }
      else {
        set_list_table(result.data);
      }
    });
  }

  useEffect(() => {
    loadList();
  }, []);

  return (
    <>
      {showLoading &&
        <div className="carregandoCmp">
          <div className="box">
            <Spinner></Spinner>
          </div>
        </div>
      }
      <div className={showDetail ? "d-none" : "content"}>
        <Row>
          <Col md="12">
            {!isDisable && <Button color="default" onClick={handleAdd}><i className="fa fa-plus"></i>  Nova Categoria</Button>}
            <Card>
              <CardHeader>
                <h4 className="titleCard">Lista de Categorias de Fiscalização</h4>
              </CardHeader>
              <CardBody>
                <Form>
                  <MaterialTable style={{ minHeight: "auto" }}
                    title=""
                    columns={[
                      { title: 'Identificação', field: 'identificacao' },
                      { title: 'Status', field: 'status' }
                    ]}
                    data={list_table}
                    isLoading={false}
                    options={{
                      ...table_style,
                      filtering: false,
                      exportButton: true
                    }}
                    actions={[
                      {
                        icon: 'search',
                        tooltip: 'Visualizar Registro',
                        onClick: (event, rowData) => handleEdit(rowData)
                      }
                    ]}
                    localization={table_translate}
                  />
                </Form>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>
      {showDetail &&
        <CategoriaFiscalizacaoFicha
          item={rowEdit}
          handleReturn={handleReturn}
        />
      }

    </>

  );
}
